import { Constants } from '@/utils/constants';
import { useRouter } from 'next/router';

/**
 * 表示中のページURLからサービス種類を取得する
 * @description ログイン画面、サービス選択画面ではnullが返る
 * @returns serviceType サービス種類
 */
const useServiceType = () => {
  const { pathname } = useRouter();

  if (!pathname) return null;

  const splitPaths = pathname.split('/');

  // ルートパスの場合
  if (splitPaths.length <= 1) return null;

  const firstPath = splitPaths[1];

  // 共通画面ではサービス種別が決められないためnullを返す。
  if (firstPath === 'login') return null;
  if (firstPath === 'service') return null;
  // `/mobile/...` 以外は固定回線系ページとして扱う。
  if (firstPath === Constants.ServiceType.MOBILE) return Constants.ServiceType.MOBILE;
  return Constants.ServiceType.HIKARI;
};

export default useServiceType;
